import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { adminGetReferralConfig, adminSetReferralConfig, adminListPromos } from "../../../Admin/adminApi";

function Toggle({ checked, onChange, label }) {
    return (
        <label className="toggle">
            <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
            <span className="tknob" />
            {label ? <span className="tlabel">{label}</span> : null}
        </label>
    );
}

export default function PromoReferralConfig() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState(null);

    const [promos, setPromos] = useState([]);
    const [active, setActive] = useState(true);
    const [promoId, setPromoId] = useState("");

    const eligiblePlainPromos = useMemo(() => {
        return Array.isArray(promos)
            ? promos.filter((p) => (p.kind === "percent" || p.kind === "fixed") && !p.is_referral)
            : [];
    }, [promos]);

    const selectedPromo = useMemo(() => {
        return eligiblePlainPromos.find((p) => String(p.id) === String(promoId)) || null;
    }, [eligiblePlainPromos, promoId]);

    async function load() {
        setLoading(true);
        setErr(null);
        try {
            const [cfg, list] = await Promise.all([adminGetReferralConfig(), adminListPromos()]);
            setPromos(Array.isArray(list) ? list : []);
            setActive(!!cfg?.active);
            setPromoId(cfg?.referred_promo_id != null ? String(cfg.referred_promo_id) : "");
        } catch (e) {
            setErr(e?.message || "Errore caricamento Referral config");
        } finally {
            setLoading(false);
        }
    }

    async function save(nextActive = active, nextPromoId = promoId) {
        setSaving(true);
        setErr(null);
        try {
            await adminSetReferralConfig({
                active: !!nextActive,
                referred_promo_id: nextPromoId ? Number(nextPromoId) : null,
            });
            toast.success("Referral config salvata");
            await load();
        } catch (e) {
            setErr(e?.message || "Errore salvataggio Referral config");
            toast.error(e?.message || "Errore salvataggio");
        } finally {
            setSaving(false);
        }
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <div className="group-card group-card--lift">
            <div className="group-head">
                <div className="gh-left plain">
                    <span className="gh-title">Configurazione promo Referral</span>
                </div>
                <div className="gh-right">
                    <button type="button" className="btn-lite" onClick={load} disabled={loading || saving}>
                        Ricarica
                    </button>
                </div>
            </div>

            <div className="group-body">
                {err ? <div className="promo-empty">{err}</div> : null}
                {loading ? (
                    <div className="promo-empty">Caricamento…</div>
                ) : (
                    <>
                        <section className="promo-config-hero promo-config-hero--compact">
                            <div className="promo-config-hero-copy">
                                <span className={`promo-status-pill ${active ? "is-on" : "is-off"}`}>
                                    {active ? "Referral attivo" : "Referral disattivo"}
                                </span>
                                <h2 className="promo-config-title">Promo per utenti invitati</h2>
                                <p className="promo-config-text">
                                    Qui scegli la promo base usata per il cliente referred. Le promo
                                    generate dal flusso referral restano nella pagina Promozioni.
                                </p>
                            </div>

                            <div className="promo-config-stats promo-config-stats--single">
                                <div className="promo-config-stat">
                                    <span className="promo-config-stat-label">Promo scelta</span>
                                    <strong className="promo-config-stat-value">
                                        {selectedPromo?.name || "Nessuna"}
                                        {selectedPromo?.requires_code && <span className="promo-config-text"> · Codice richiesto: si applica dopo l’inserimento del codice, anche per gli utenti invitati.</span>}
                                    </strong>
                                </div>
                            </div>
                        </section>

                        <div className="panel panel--soft">
                            <div className="panel-head">
                                <div className="panel-title">Impostazioni base</div>
                            </div>

                            <div className="panel-body">
                                <div className="form-grid f4 promo-form-compact">
                                    <label className="span-2">
                                        Attivo
                                        <Toggle
                                            checked={active}
                                            onChange={(v) => {
                                                setActive(v);
                                                save(v, promoId);
                                            }}
                                        />
                                    </label>

                                    <label className="span-2">
                                        Promo base “referred” (plain)
                                        <select value={promoId} onChange={(e) => setPromoId(e.target.value)}>
                                            <option value="">— Nessuna —</option>
                                            {eligiblePlainPromos.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    #{p.id} {p.name || "—"} {p.code ? `· ${p.code}` : ""}
                                                </option>
                                            ))}
                                        </select>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="promo-actions-right">
                            <button type="button" className="btn-cta" onClick={() => save(active, promoId)} disabled={saving}>
                                💾 Salva
                            </button>
                        </div>

                        <p className="promo-hint">
                            Qui scegli solo la promo base. Le promo generate dal referral stanno nella pagina “Promozioni”.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}
